<template>
  <el-card>
    <div
      class="reportChart"
      v-show="
        !(
          config &&
          config.chart &&
          config.chart.series &&
          config.chart.series[0].data &&
          config.chart.series[0].data.length === 0
        )
      "
    >
      <div>
        <slot name="left"></slot>
      </div>
      <div class="right">
        <div :ref="option.ref" :style="`flex:1;height:${option.height};`"></div>
      </div>
    </div>
    <defaultData
      :custom="{ height: option.height }"
      v-show="
        config &&
        config.chart &&
        config.chart.series &&
        config.chart.series[0].data &&
        config.chart.series[0].data.length === 0
      "
      style="flex: 1"
    ></defaultData>
  </el-card>
</template>

<script>
import defaultData from '@/components/common/default-data'
import echarts from '../../../../public/js/echart/echarts.min.js'
import echartsJson from '../../../../public/js/echart/customed.json'
import { formatNumberMix, rotateReport } from '@/utils'
import { pickerOptions } from '@/utils/datepickerConfig'
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  name: 'reportChart',
  components: {
    defaultData,
  },
  props: {
    config: {
      default: () => {},
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        if (this.charts) {
          setTimeout(() => {
            this.charts.resize()
          }, 60)
        }
      })
    })
  },
  computed: {
    ...mapState(['menu']),
  },
  watch: {
    config: {
      handler: function (config) {
        this.option = {
          ...config,
        }
        this.filter = this.option ? this.option.filter : ''
        this.initChart(this.option)
      },
      immediate: true,
      deep: true,
    },
    'menu.collapse': {
      handler: function (val) {
        if (this.charts) {
          setTimeout(() => {
            this.charts.resize()
          }, 60)
        }
      },
    },
  },
  activated() {
    if (this.charts) {
      setTimeout(() => {
        this.charts.resize()
      }, 600)
    }
  },
  data() {
    return {
      resize: null,
      charts: null,
      pickerOptions,
      filter: '',
      option: {},
    }
  },
  methods: {
    initChart(option) {
      setTimeout(() => {
        if (!(option && option.ref)) {
          return
        }
        const refs = this.$refs[option.ref]
        if (!refs) {
          return
        }
        // 指定图表的配置项和数据
        if (!option.chart) {
          return
        }
        if (option.type === 'line') {
          option.chart = this.lineChart(option.chart)
        }
        if (option.type === 'lineAndBar') {
          option.chart = this.lineAndBar(option.chart)
        }
        if (option.type === 'bar') {
          option.chart = this.barChart(option.chart)
        }
        if (option.type === 'ring') {
          option.chart = this.ringChart(option.chart)
        }
        if (option.type === 'funnel') {
          option.chart = this.funnelChart(option.chart)
        }

        if (this.charts) {
          this.charts.setOption(option.chart)
          this.charts.resize()
          return
        }
        echarts.registerTheme('customed', echartsJson)
        this.charts = echarts.init(refs, 'customed')
        refs.style.height = option.height
        this.charts.setOption(this.$deepClone(option.chart))
        this.charts.resize()
      }, 60)
    },
    onBtnClick(emit) {
      if (emit.link) this.$router.push(emit.link)
      this.$emit('btns', emit)
    },
    ySplitLine() {
      return {
        lineStyle: {
          color: '#999999',
          type: 'dashed',
        },
      }
    },
    gridConfig() {
      return {
        top: '4%',
        left: '3%',
        right: '4%',
        bottom: '12%',
        containLabel: true,
      }
    },
    legendConfig() {
      return {
        left: 'center',
        itemWidth: 12,
        itemHeight: 6,
        bottom: 0,
        itemGap: 24,
      }
    },
    // 双折线
    lineChart(option) {
      if (!option) {
        return {}
      }
      return {
        tooltip: {
          trigger: 'axis',
          ...(option.tooltip ? option.tooltip : {}),
        },
        legend: {
          ...this.legendConfig(),
          data: [],
          ...(option.legend ? option.legend : {}),
        },
        grid: {
          ...this.gridConfig(),
        },
        xAxis: {
          axisLabel: {
            margin: 16,
            color: '#999999',
            rotate: rotateReport(this, option.xAxis.data || []),
          },
          axisLine: {
            lineStyle: {
              color: '#999999',
            },
          },
          type: 'category',
          boundaryGap: true,
          data: [],
          ...option.xAxis,
        },
        yAxis: option.yAxis
          ? option.yAxis
          : [
              {
                splitLine: this.ySplitLine(),
                axisLabel: {
                  margin: 16,
                  color: '#999999',
                },
                type: 'value',
              },
            ],
        series: option.series ? option.series : [],
      }
    },
    // 折柱混合 line-Bar
    lineAndBar(option) {
      if (!option) {
        return {}
      }
      return {
        tooltip: {
          trigger: 'axis',
          ...(option.tooltip ? option.tooltip : {}),
        },
        legend: {
          ...this.legendConfig(),
          data: [],
          ...(option.legend ? option.legend : {}),
        },
        grid: {
          ...this.gridConfig(),
        },

        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#999999',
            },
          },

          axisLabel: { rotate: rotateReport(this, option.xAxis.data || []), margin: 16, color: '#999999' },
          boundaryGap: true,
          data: [],
          ...(option.xAxis ? option.xAxis : {}),
        },
        yAxis: option.yAxis
          ? option.yAxis
          : [
              {
                type: 'value',
                splitLine: this.ySplitLine(),
                min: 0,
                axisLabel: {
                  margin: 16,
                  color: '#999999',
                },
              },
              {
                type: 'value',
                min: 0,
                splitLine: {
                  show: false,
                },
                axisLabel: {
                  margin: 16,
                  color: '#999999',
                },
              },
            ],
        series: option.series ? option.series : [],
      }
    },
    handleFilter(value) {
      this.$emit('change', value)
    },
    // 柱图
    barChart(option) {
      if (!option) {
        return {}
      }
      return {
        tooltip: {
          trigger: 'axis',
          ...(option.tooltip ? option.tooltip : {}),
        },
        legend: {
          ...this.legendConfig(),
          data: [],
          ...(option.legend ? option.legend : {}),
        },
        grid: {
          top: '4%',
          left: '3%',
          right: '4%',
          bottom: '12%',
          containLabel: true,
        },

        xAxis: {
          type: 'category',
          axisLine: {
            lineStyle: {
              color: '#999999',
            },
          },
          axisLabel: { rotate: rotateReport(this, option.xAxis.data || []), margin: 16, color: '#999999' },
          boundaryGap: true,
          data: [],
          ...option.xAxis,
        },
        yAxis: option.yAxis
          ? option.yAxis
          : [
              {
                type: 'value',
                // name: '水量',
                min: 0,
                splitLine: this.ySplitLine(),
              },
            ],
        series: option.series ? option.series : [],
        boundaryGap: true,
      }
    },
    // 环图
    ringChart(option) {
      if (!option) {
        return {}
      }
      console.log(option)
      return {
        tooltip: {
          trigger: 'item',
          borderColor: '#fff',
          ...(option.tooltip ? option.tooltip : {}),
        },
        legend: {
          bottom: 0,
          left: 'center',
          ...(option.legend ? option.legend : {}),
          // type: 'scroll',
          // orient: 'vertical',
          // right: 0,

          // textStyle: {
          //   width: 100,
          //   overflow: 'break'
          // }
        },
        grid: {
          ...this.gridConfig(),
        },
        graphic: option.graphic ? option.graphic : [],
        series: option.series ? option.series : [],
        color: option.color ? option.color : [],
      }
    },
    // 漏斗
    funnelChart(option) {
      if (!option) {
        return {}
      }
      return {
        tooltip: {
          trigger: 'item',
          borderColor: '#fff',
          ...(option.tooltip ? option.tooltip : {}),
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 0,

          textStyle: {
            width: 100,
            overflow: 'break',
          },
          ...(option.legend ? option.legend : {}),
        },
        grid: {
          ...this.gridConfig(),
        },
        series: option.series ? option.series : [],
      }
    },
  },
}
</script>

<style scoped lang="scss">
.reportChart {
  display: flex;
  .right {
    flex: 1;
  }
}
</style>
